// Basic
import PropTypes from 'prop-types';
import { useState } from 'react';
// Store & Actions
import useSessionStore from '@/app/store/session';
// Components
import Dropdown from '../../../../../common-utils/components/renders/dropdown/Dropdown';
import ModalDomiciliation from '../modals/ModalDomiciliation';
import ModalUpdateLabel2 from '../modals/ModalUpdateLabel2';
// Common
import ICONS from '../../../../../common-utils/enums/icons';
import Permissions from '@/app/permissions/Permissions';
import contractFields from '../../fields/contractFields';
import MerchantContractDomiciliation from '@/common-utils/enums/MerchantContractDomiciliation';
// Lang
import { nsContract } from '@/app/i18n/namespaces';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';

/**
 * Dropdown component for contract actions
 * @param {Object} props
 * @param {Object} props.contract - The contract object
 * @param {Function} props.setLaunchRefetch - Function to trigger refetch
 * @param {string} props.toastSuccess - Success message for toast
 * @returns {JSX} DropdownTerminalContractActionsRow
 */
function DropdownTerminalContractActionsRow({ contract, setLaunchRefetch }) {
    // Store
    const permissions = useSessionStore(s => s.session.permissions);

    // State
    const [showModalUpdateLabel2, setShowModalUpdateLabel2] = useState(false);
    const [showModalDomiciliation, setShowModalDomiciliation] = useState(false);

    // Constants
    const contractNumber = contract ? contract[contractFields.NUMBER.key] : null;
    const application = contract ? contract[contractFields.APPLICATION.key] : null;

    return (
        <>
            <Dropdown
                dataCy='terminal-contract-actions-dropdown-row'
                triggerValues={{ variant: 'ghostNoBorder', icon: ICONS.MORE }}
                actions={[
                    {
                        icon: ICONS.EDIT,
                        entity: 'actions.row.update_label',
                        namespace: nsContract,
                        onClick: () => setShowModalUpdateLabel2(true),
                        visible: true,
                        disabled: !hasRequiredPermissions({
                            permissions: permissions,
                            requiredPermissions: [Permissions.MERCHANT_CONTRACT_UPDATE.name]
                        }),
                        tooltipForbidden: 'title.permissions.access_denied'
                    }, {
                        icon: ICONS.CREDIT_CARD,
                        entity: 'actions.row.domiciliation',
                        namespace: nsContract,
                        onClick: () => setShowModalDomiciliation(true),
                        visible: MerchantContractDomiciliation[application] !== undefined
                    }
                ]}
            />
            <ModalUpdateLabel2
                isOpen={showModalUpdateLabel2}
                setIsOpen={setShowModalUpdateLabel2}
                contractId={contract.uuid}
                label={contract.label}
                application={contract.application}
                setLaunchRefetch={setLaunchRefetch}
            />
            <ModalDomiciliation
                isOpen={showModalDomiciliation}
                setIsOpen={setShowModalDomiciliation}
                contractNumber={contractNumber}
                applicationCode={application}
            />
        </>
    );
}

DropdownTerminalContractActionsRow.propTypes = {
    contract: PropTypes.object.isRequired,
    setLaunchRefetch: PropTypes.func.isRequired
};

export default DropdownTerminalContractActionsRow;
